module.exports = __webpack_public_path__ + "static/media/accountOn.b99e6e4e.svg";